import React, { useEffect, useMemo, useState } from "react";
import { SiteLayout } from "@/components/SiteLayout";
import { useI18n } from "@/lib/i18n";
import { api, rp } from "@/lib/api";
import { PackageCard } from "@/pages/Landing";
import { logError } from "@/lib/log";

const CTA_BOOK_NOW = { select: null };

export default function PackagesPage() {
  const { t } = useI18n();
  const [pkgs, setPkgs] = useState([]);
  const [addons, setAddons] = useState([]);
  const cta = useMemo(() => ({ ...CTA_BOOK_NOW, select: t("bookNow") }), [t]);
  useEffect(() => {
    api.get("/public/packages").then((r) => setPkgs(r.data)).catch((e) => logError("Failed to load packages", e));
    api.get("/addons", { params: { public: 1 } }).then((r) => setAddons(r.data)).catch(() => setAddons([]));
  }, []);
  return (
    <SiteLayout>
      <div className="mx-auto max-w-6xl px-5 py-16">
        <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">{t("packages")}</h1>
        <div data-testid="packages-grid" className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {pkgs.map((p) => <PackageCard key={p.id} p={p} ctaLabel={cta} />)}
        </div>

        {addons.length > 0 && (
          <div className="mt-16" data-testid="public-addons">
            <h2 className="text-base md:text-lg font-semibold">Tambahan</h2>
            <div className="mt-5 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {addons.map((a) => (
                <div key={a.id} data-testid={`addon-card-${a.id}`} className="lm-card rounded-xl p-6">
                  <div className="font-display text-2xl tracking-tight">{a.name}</div>
                  <div className="mt-2 font-display text-xl text-lm-red">{rp(a.price)}</div>
                  {a.description && <p className="mt-3 text-sm text-ink-soft">{a.description}</p>}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </SiteLayout>
  );
}
